import request from "@/utils/request.js";
/**
 *获取用户课程列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listUserCourse(params) {
  return request({
    url: "/coreService/api/pc/course/listUserCourse2",
    method: "post",
    data: params
  });
}

/**
 *获取机构课程列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listCourseGoodsByOrg(params) {
  return request({
    url: "/coreService/api/pc/course/listCourseGoodsByOrg2",
    method: "post",
    data: params
  });
}

/**
 * 获取课程介绍
 * @param params
 * @returns {AxiosPromise}
 */
export function getCourseIntroduce(params) {
  return request({
    url: "/coreService/api/pc/course/getCourseIntroduce",
    method: "post",
    data: params
  });
}
/**
 * 获取课程介绍
 * @param params
 * @returns {AxiosPromise}
 */
export function getOrgUserStudyExpire(params) {
  return request({
    url: "/coreService/api/app/card/getOrgUserStudyExpire",
    method: "post",
    data: params
  });
}
/**
 * 订阅和取消订阅
 * @param params
 * @returns {AxiosPromise}
 */
export function subscribe(params) {
  return request({
    url: "/coreService/api/pc/course/subscribe",
    method: "post",
    data: params
  });
}

/**
 * 获取第三方端链接
 * @param params
 * @returns {AxiosPromise}
 */
export function getRwsCourseUrl(params) {
  return request({
    url: "coreService/api/pc/course/getRwsCourseUrl",
    method: "post",
    data: params
  });
}
